import React from "react";
import logo from '../img/icons8-fruits-64.png'
import {Link} from 'react-router-dom';
import '../css/Style.css';
import Scrolltop from '../inc/Scrolltop';
function Footer(){
    return(
        <div className="container-fluid bg">
        <div class="container">
        <footer class="row row-cols-1 row-cols-sm-2 row-cols-md-5 p-3">
            <div class="col mb-3">
            <h5 className="text-white">Links</h5>
            <div class="fancy-border"></div>
            <ul class="nav flex-column mt-2">
                <li class="nav-item mb-2 "><Link class="nav-link p-0 text-white" to="/">Home</Link> </li>
                <li class="nav-item mb-2"><Link class="nav-link p-0 text-white" to="/about">About</Link></li>
                <li class="nav-item mb-2"><Link class="nav-link p-0 text-white" to="/contact">Contact</Link></li>
                <li class="nav-item mb-2"><Link class="nav-link p-0 text-white" to="/ourfruit">Ourfruits</Link></li>
                <li class="nav-item mb-2"><Link class="nav-link p-0 text-white" to="/testimonial">Testimonials</Link></li>
            </ul>
            </div>

            <div class="col mb-3">
            <h5  className="text-white">Information</h5>
            <div class="fancy-border"></div>
            <ul class="nav flex-column mt-2">
                <li class="nav-item mb-2"><a href="https://www.google.com/maps/dir//Fruits+Shop,+Biripur,+Gobara,+Odisha+761124/@19.8329567,84.5944268,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3a22c180dba1588b:0x1c82766e3e94fff1!2m2!1d84.5970017!2d19.8329567?entry=ttu" class="nav-link p-0 text-white">Location & Directions</a></li>
                <li class="nav-item mb-2"><a href="https://www.google.com/maps/place/Fruits+Shop/@19.8329567,84.5944268,17z/data=!4m8!3m7!1s0x3a22c180dba1588b:0x1c82766e3e94fff1!8m2!3d19.8329567!4d84.5970017!9m1!1b1!16s%2Fg%2F11vf20lwc8?entry=ttu" class="nav-link p-0 text-white">Give Review</a></li>
                <li class="nav-item mb-2"><Link class="nav-link p-0 text-white" to="/sitemap">Sitemap</Link></li>
                <li class="nav-item mb-2"><Link class="nav-link p-0 text-white" to="/faq">FAQs</Link></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white">News</a></li>
            </ul>
            </div>

            <div class="col mb-3">
            <h5  className="text-white">Follow Us</h5>
            <div class="fancy-border"></div>
            <ul class="nav flex-column mt-2">
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white"><i class="bi bi-instagram"></i></a></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white"><i class="bi bi-meta"></i></a></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white"><i class="bi bi-whatsapp"></i></a></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white"><i class="bi bi-snapchat"></i></a></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white"><i class="bi bi-telegram"></i></a></li>
            </ul>
            </div>
            <div class="col mb-3">
            <h5  className="text-white">Fruits</h5>
            <div class="fancy-border"></div>
            <ul class="nav flex-column mt-2">
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white">Apples</a></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white">Grape</a></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white">Lemons</a></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white">Kiwi</a></li>
                <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-white">Nectarines</a></li>
            </ul>
            </div>

            <div class="col mb-3 p-3">
            <a href="/" class="d-flex align-items-center  link-body-emphasis text-decoration-none">
                <img className="img-fluid d-block mx-auto" src={logo}/>
            </a>
            <h2 className="fw-blod text-white mb-3"><small>FruitsShop</small></h2>
            <p class="text-white">© Allright Reserved 2023 | Designed by Fruits Shop</p>
            </div>
        </footer>
     </div>
<Scrolltop/>
</div>
    );
}
export default Footer;